"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _regeneratorValues2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regeneratorValues.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _lodash = _interopRequireDefault(require("lodash"));
var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));
var _index = _interopRequireDefault(require("@/components/UploadExcel/index.vue"));
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _hike = require("@/api/hike");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import moment from 'moment-timezone'
// import Tinymce from '@/components/Tinymce'
// import QrcodeVue from 'qrcode.vue'
// import { truncate } from '@/filters'
// const defaultValue = []
var _default = exports.default = {
  name: 'HikeAwardSteps',
  components: {
    UploadExcelComponent: _index.default
  },
  directives: {
    elDragDialog: _elDragDialog.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      fullscreenloading: false,
      hike: null,
      myHikeTeams: [],
      myHikeTeamEmails: [],
      isShowResult: false,
      noOfSuccess: 0,
      noOfFail: 0,
      tableData: [],
      tableHeader: [],
      smallDrop: 'smallDrop',
      loading: false
    };
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.getHike();
          case 1:
            _context.n = 2;
            return _this.getHikeParticipantsSteps();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    handleDrag: function handleDrag() {
      // this.$refs.select.blur()
    },
    openDialog: function openDialog() {
      this.tableData = [];
      this.tableHeader = [];
      this.isShowResult = false;
      this.dialogVisible = true;
    },
    handleSuccess: function handleSuccess(_ref) {
      var results = _ref.results,
        header = _ref.header;
      // console.log('upload excel file-result', results)
      // console.log('upload excel file-header', results)
      this.tableData = _lodash.default.map(results, function (r) {
        return {
          email: _lodash.default.trim(_lodash.default.toLower(r.email)),
          step: _lodash.default.trim(r.step)
        };
      });
      this.tableHeader = header;
    },
    beforeUpload: function beforeUpload(file) {
      // console.log('upload excel file', file)
      return true;
    },
    doUpload: function doUpload() {
      if (this.tableData.length <= 0) {
        var msg = this.$i18n.t('otrTraining.msgEmptyRecord');
        (0, _log.displayPopupMessage)(msg, 'error');
        return false;
      }
      var hikeId = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      var oEmail = (0, _cookie.getCookie)('EMAIL');
      this.fullscreenloading = true;
      this.isShowResult = false;
      this.noOfFail = 0;
      this.noOfSuccess = 0;
      this.updateSteps();
      (0, _ga.writeGaEvent)(this, 'Hike', "".concat(_lifehikesInitData.userEvent.hike.uploadParticipant), oEmail, "Hike Id: ".concat(hikeId));
    },
    EmailFormatErrorStyle: function EmailFormatErrorStyle(email) {
      if (email !== '' && !this.myHikeTeamEmails.includes(email)) {
        return 'error';
      }
      var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return !re.test(email) && email !== '' ? 'error' : '';
    },
    StepFormatErrorStyle: function StepFormatErrorStyle(step) {
      var re = /^\d+$/;
      return !re.test(step) && step !== '' ? 'error' : '';
    },
    updateSteps: function updateSteps() {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var i, re, msg, _msg, _msg2, reStep, _msg3, _msg4, token, _loop, _i;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              i = 0;
            case 1:
              if (!(i < _this2.tableData.length)) {
                _context3.n = 7;
                break;
              }
              re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!(_this2.tableData[i].email === '')) {
                _context3.n = 2;
                break;
              }
              msg = 'Please check the email in row ' + (i + 1) + " , it's empty.";
              (0, _log.displayPopupMessage)(msg, 'error');
              _this2.fullscreenloading = false;
              return _context3.a(2);
            case 2:
              if (!(_this2.tableData[i].email !== '' && !re.test(_this2.tableData[i].email))) {
                _context3.n = 3;
                break;
              }
              _msg = 'Please check the email format in row ' + (i + 1);
              (0, _log.displayPopupMessage)(_msg, 'error');
              _this2.fullscreenloading = false;
              return _context3.a(2);
            case 3:
              if (_this2.myHikeTeamEmails.includes(_this2.tableData[i].email)) {
                _context3.n = 4;
                break;
              }
              _msg2 = 'Please check the email in row ' + (i + 1) + " , it's not in participant list.";
              (0, _log.displayPopupMessage)(_msg2, 'error');
              _this2.fullscreenloading = false;
              return _context3.a(2);
            case 4:
              reStep = /^\d+$/;
              if (!(_this2.tableData[i].step === '' || _this2.tableData[i].step !== '' && !reStep.test(_this2.tableData[i].step))) {
                _context3.n = 5;
                break;
              }
              _msg3 = 'Please check the step in row ' + (i + 1);
              (0, _log.displayPopupMessage)(_msg3, 'error');
              _this2.fullscreenloading = false;
              return _context3.a(2);
            case 5:
              if (!(_this2.tableData[i].step > 999)) {
                _context3.n = 6;
                break;
              }
              _msg4 = 'Please check the step in row ' + (i + 1) + ', max is 999';
              (0, _log.displayPopupMessage)(_msg4, 'error');
              _this2.fullscreenloading = false;
              return _context3.a(2);
            case 6:
              i++;
              _context3.n = 1;
              break;
            case 7:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              _this2.isShowResult = true;
              _loop = /*#__PURE__*/(0, _regenerator2.default)().m(function _loop(_i) {
                var data;
                return (0, _regenerator2.default)().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      data = {
                        'userUuid': _this2.myHikeTeams.find(function (element) {
                          return element.email === _this2.tableData[_i].email;
                        }).uuid,
                        'step': _this2.tableData[_i].step
                      };
                      _context2.n = 1;
                      return (0, _hike.updateParticipantStep)(token, _this2.hike.id, data).then(function (response) {
                        (0, _log.showDebugLog)('registerEnroll-API-OK', response.data);
                        _this2.tableData[_i].result = 'Success';
                        _this2.$set(_this2.tableData, _i, _this2.tableData[_i]);
                        (0, _log.showDebugLog)('Table content row', _i);
                        _this2.noOfSuccess += 1;
                      }).catch(function (error) {
                        // showDebugLog('registerEnroll-API-Fail', error.response)
                        var msg = typeof error.response === 'undefined' ? error.toString() : error.response.data.message;
                        _this2.noOfFail += 1;
                        _this2.tableData[_i].result = 'Fail:' + msg;
                        _this2.$set(_this2.tableData, _i, _this2.tableData[_i]);
                        // showDebugLog('registerEnroll-API-Fail', msg)
                        (0, _log.showDebugLog)('Table content row', _i);
                      });
                    case 1:
                      return _context2.a(2);
                  }
                }, _loop);
              });
              _i = 0;
            case 8:
              if (!(_i < _this2.tableData.length)) {
                _context3.n = 10;
                break;
              }
              return _context3.d((0, _regeneratorValues2.default)(_loop(_i)), 9);
            case 9:
              _i++;
              _context3.n = 8;
              break;
            case 10:
              _context3.n = 11;
              return _this2.getHikeParticipantsSteps();
            case 11:
              _this2.fullscreenloading = false;
            case 12:
              return _context3.a(2);
          }
        }, _callee2);
      }))();
    },
    getHike: function getHike() {
      var _this3 = this;
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      (0, _hike.getHikeById)(token, id).then(function (response) {
        _this3.hike = response.data;
        _this3.loading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('hike-getHikeById-error', error);
        _this3.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    getHikeParticipantsSteps: function getHikeParticipantsSteps() {
      var _this4 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var token, id;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              id = typeof _this4.$route.params.id === 'undefined' ? '' : _this4.$route.params.id;
              _context4.n = 1;
              return (0, _hike.getParticipantsSteps)(token, id).then(function (response) {
                _this4.myHikeTeams = response.data.rows;
                _this4.myHikeTeamEmails = response.data.rows.map(function (row) {
                  return row.email;
                });
              }).catch(function (error) {
                (0, _log.showDebugLog)('Hike-getParticipantsSteps-API-error', error);
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee3);
      }))();
    },
    backToHike: function backToHike() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push("/hike/edit/".concat(id));
    }
  }
};